<template>
  <div class="offer-page-container">
    <div class="offers-header">
      <img :src="`/images/triangle/triRewards_logo_${this.language}.png`" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";

export default {
  name: "OffersPageHeader",
  mixins: [blockElementMixin],
  computed: {
    ...mapGetters(['language']),
  },
}
</script>

<style lang="scss" scoped>
.offer-page-container{
  position: relative;
  width: 100%;

  .band{
    background-color: #78CCC7;;
    height:0.5em;
  }
  .offers-header{
    height: 30%;
    img{
      margin: 0.5em 0;
      max-width: 100%;
    }
  }
}
</style>

<style lang="scss">
[mode='mobile'] [page-id='offersPage'].section-container {
	&>.flyer-block.OffersPage {
		grid-area: span 4 / span 2 / auto / auto !important;
	}
}
</style>